/**
 * Safely trim values that are either strings or nullish.
 *
 * Does **not** do actual type conversion or anything else, this is
 * just a very simple utility method to avoid having to put an Elvis
 * operator on the trim method for every single field in a form, etc.
 *
 * @param value - the string (which may be undefined) to safely trim.
 */
export const safeTrim = (value: string): string => {
  return (value || '').trim();
};
